interface LikeProps {
    color?: 'Default' | 'White'; 
}

const COLOR_SCHEMES = {
    Default: '#6B6B6B',
    White: '#FFFFFF'    
};

export const Like: React.FC<LikeProps> = ({ color: colorScheme = 'Default' }) => {
    const color = COLOR_SCHEMES[colorScheme];

    return (
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
                d="M15.8685 1.96415C17.7535 3.85415 17.8185 6.86415 16.0652 8.82748L8.99852 15.9042L1.93352 8.82748C0.180187 6.86415 0.246021 3.84915 2.13019 1.96415C4.01769 0.0774834 7.03685 0.0141499 9.00019 1.77415C10.9577 0.0166499 13.9827 0.0749834 15.8685 1.96415ZM3.30935 3.14332C2.06769 4.38498 2.00519 6.37248 3.14935 7.68582L8.99935 13.545L14.8494 7.68665C15.9944 6.37248 15.9319 4.38748 14.6885 3.14165C13.4494 1.89998 11.4544 1.83998 10.1444 2.98665L6.64269 6.48915L5.46352 5.31082L7.81769 2.95498L7.74935 2.89748C6.43685 1.84332 4.51852 1.93332 3.30935 3.14332Z"
                fill={color}
            />
        </svg>
    );
};
